/* unplugin-vue-components disabled */import { render } from "./domain.vue?vue&type=template&id=5fc1c208"
import script from "./domain.vue?vue&type=script&lang=js"
export * from "./domain.vue?vue&type=script&lang=js"

import "./domain.vue?vue&type=style&index=0&id=5fc1c208&lang=css"

import exportComponent from "F:\\vue2.0+ vant\\2024年项目集合\\元羿官网项目集合\\元羿中文版本\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__